import { useQuery } from '@tanstack/react-query';
import { ExtractFnReturnType } from '@/lib/react-query';
import { getConsolidationDataByType } from '@/features/dashboard/api/getConsolidationDataByType.ts';
import { TypesConsolidationData } from '@/types/ConsolidationData.ts';

type QueryFnType = typeof getConsolidationDataByType;

function useConsolidationPedagogicalCashFlow({year}) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-consolidation-pedagogical-cash-flow', year],
    queryFn: () => getConsolidationDataByType(TypesConsolidationData.SCORE_FLUXO_CAIXA, year),
  });
}

export { useConsolidationPedagogicalCashFlow };
